import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function FeaturedComics() {
  const featured = comics.filter(c => c.isFeatured).slice(0, 6);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              精选推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-2">编辑精心挑选的高质量韩漫作品</p>
          </div>
          <Link
            to="/category/all"
            className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium cursor-pointer whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5" data-product-shop="">
          {featured.map(comic => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  title={`${comic.title} - 韩国漫画无删减`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                  <span className="inline-block bg-primary-500 text-white text-xs px-2 py-0.5 rounded-full">
                    立即阅读
                  </span>
                </div>
                <div className="absolute top-2 left-2">
                  <span className="inline-block bg-accent-500 text-white text-xs font-semibold px-2 py-0.5 rounded-full">
                    {comic.rating}
                  </span>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1">{comic.author} · {comic.status}</p>
            </Link>
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-1 text-sm text-primary-600 font-medium cursor-pointer whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}